<script lang="ts">
  import { type Snippet } from 'svelte';

  import { EntityForm, Button } from '$shared/components';
  import FormProgressBar from './partial/FormProgressBar.svelte';
  import type { EntityFormOption } from '$shared/components/types';
  import { ButtonStyle } from '$shared/constants/ButtonStyle';

  interface Props {
    // EntityForm passthrough props
    loading?: boolean;
    processing?: boolean;
    disabled?: boolean;
    options: EntityFormOption;
    steps?: number;
    headerAction?: Snippet | undefined;
    step1?: Snippet | undefined;
    step2?: Snippet | undefined;
    onok?: () => void;
  }

  let {
    loading = false,
    processing = false,
    disabled = false,
    options,
    steps = 2,
    headerAction = undefined,
    step1 = undefined,
    step2 = undefined,
    onok
  }: Props = $props();

  let entityForm: EntityForm = $state();
  export const scrollToErrorView = (): void => entityForm?.scrollToErrorView();

  // Internal step state — not exposed as a prop
  let currentStep = $state(1);
  let isFinalStep = $derived(currentStep === steps);
  let isFirstStep = $derived(currentStep === 1);

  const onClickSave = (): void => {
    onok?.();
  };
</script>

<div class="wizard-entity-form">
  <FormProgressBar totalSteps={steps} {currentStep} />
  {#snippet footerAction()}
    <div class="wizard-actions">
      {#if !isFirstStep}
        <Button name="back" style={ButtonStyle.Secondary} onclick={() => currentStep--}>
          Back
        </Button>
      {/if}
      {#if !isFinalStep}
        <Button name="next" style={ButtonStyle.Primary} onclick={() => currentStep++}>
          Next
        </Button>
      {:else}
        <Button name="finish" style={ButtonStyle.Primary} {loading} onclick={onClickSave}>
          Save
        </Button>
      {/if}
    </div>
  {/snippet}
  <EntityForm bind:this={entityForm} {processing} {disabled} {...options} customActions {headerAction} {footerAction}>
    {#if currentStep === 1}
      {@render step1?.()}
    {:else if currentStep === 2}
      {@render step2?.()}
    {/if}
  </EntityForm>
</div>

<style>
  .wizard-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  :global(.wizard-entity-form .entity-form) {
    height: calc(100vh - 4px) !important;
  }
</style>
